// extracted by mini-css-extract-plugin
export default {"overlay":"Qx-z","bodyOpen":"Rx-z","content":"Sx-z","header":"Tx-z","close":"Ux-z","closeNoHeading":"Vx-z"};